module.exports = __webpack_public_path__ + "img/linet-logo.d9676837.svg";